var exports = {
  "w": "header__uf-BDH",
  "P": "previewLabel__OmKjFl",
};

module.exports = exports;
